import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { z } from 'zod';

import Logo from '@/assets/icons/logo.svg?react';
import {
  AUTH_CALLBACK_MESSAGE_PREFIX,
  AUTH_CALLBACK_STORAGE_KEY,
} from '@/features/login/callback-adapter';

const redirectParamsSchema = z.object({
  code: z.string().catch(''),
  state: z.string().catch(''),
  error: z.string().optional(),
  error_description: z.string().optional(),
});

export const Route = createFileRoute('/auth-callback/')({
  component: RouteComponent,
  validateSearch: (search) => redirectParamsSchema.parse(search),
});

function RouteComponent() {
  const params = Route.useSearch();
  const hasSentCallbackRef = useRef(false);

  useEffect(() => {
    if (hasSentCallbackRef.current) return;
    hasSentCallbackRef.current = true;

    const callbackPayload = JSON.stringify(params);
    window.opener?.postMessage(
      `${AUTH_CALLBACK_MESSAGE_PREFIX}${callbackPayload}`,
      window.location.origin
    );
    localStorage.removeItem(AUTH_CALLBACK_STORAGE_KEY);
    localStorage.setItem(AUTH_CALLBACK_STORAGE_KEY, callbackPayload);
    window.close();
  }, [params]);

  return (
    <div className="flex fixed inset-0 w-screen min-h-full items-center justify-center p-4 bg-background text-foreground">
      <div className="flex flex-col gap-2 justify-center align-middle">
        <Logo aria-label="Littlebird" className="mx-auto size-6" />
        Login successful. You can close this tab.
      </div>
    </div>
  );
}
